const strings = {
  EMAIL: {
    SE: 'Email',
    EN: 'Email'
  },
  REPEAT_EMAIL: {
    SE: 'Upprepa email',
    EN: 'Repeat email'
  },
  EMAILS_DO_NOT_MATCH: {
    SE: 'Emailadresserna matchar ej',
    EN: 'The emails do not match'
  },
  MANDATORY_FIELD: {
    SE: 'Obligatoriskt fält',
    EN: 'Mandatory field'
  },
  NOT_VALID_EMAIL: {
    SE: 'Emailadressen är ej giltig',
    EN: 'Not valid email'
  },
  EMAIL_IN_USE: {
    SE: 'Emailadressen är redan i bruk, var god välj en annan',
    EN: 'The email is already in use, please use another'
  },
  INTERNAL_ERROR: {
    SE: 'Ett oväntat fel har uppstått, var god försök igen.',
    EN: 'An unexpected error has occured, please try again.'
  },
  EDIT_EMAIL: {
    SE: 'Uppdatera email',
    EN: 'Edit email'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditEmailModal/strings.js